var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tinymceVue-Box"},[_c('div',{staticClass:"tinymceVue",style:({'min-height': '200px'})},[_c('editor',{attrs:{"id":_vm.tinymceID,"init":_vm.initOptions,"disabled":_vm.disabled}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }